import React, { useState, useEffect } from 'react';
import styles from './sendOfferConfigurations.module.scss';
import Select from 'react-select'
import * as yup from 'yup';
import { Formik } from 'formik';
import makeAnimated from 'react-select/animated';
import { Col, Row, Form } from 'react-bootstrap';

import "react-datetime/css/react-datetime.css";
import { CustomButton } from '../../../../shared/customButton';
import CustomDropZone from '../../../../shared/customDropZone';
import { Tooltip as ReactTooltip } from 'react-tooltip'

const SendOfferConfigurations = (props) => {
    // let [options, setOptions] = useState([]);
    // let [allTimeZones, setAllTimeZones] = useState();
    // let [allReviwers, setallReviewers] = useState(props.interviewers);
    // let [timeZone, setTimeZone] = useState(props.timeZone.value);
    // const animatedComponents = makeAnimated();
    // const dropValue = [
    //     {
    //         label: 'Online Interview',
    //         value: 0,
    //     },
    //     {
    //         label: 'Physical Interview',
    //         value: 1,
    //     },
    // ]

    //yup validations
    const schema = yup.object({
        offerLetter: yup.array().required('Required'),
    });

    //check validity of dates
    // let yesterday = moment().tz(timeZone).subtract(1, 'day');
    // let valid = function (current) {
    //     return current.isAfter(yesterday);
    // };

    //on submit function
    const onSubmit = async (values) => {
        props.updateValues({ offerLetter: values.offerLetter });
        props.nextPage(2)
    }



    // useEffect(() => {
    //     let unmounted = false;
    //     const setInitialValues = async () => {
    //         if (!unmounted) {
    //             let array = [];
    //             let reviewers = [];
    //             let values = moment.tz.names();
    //             let reviewesList = await getAllReviewers();
    //             values.forEach(value => {
    //                 array.push({
    //                     value: value,
    //                     label: value
    //                 })
    //             });
    //             reviewesList.data.forEach(value => {
    //                 reviewers.push({
    //                     _id: value._id,
    //                     user_id: {
    //                         email: value.user_id.email,
    //                         name: value.user_id.first_name + ' ' + value.user_id.last_name
    //                     }
    //                 });
    //             });
    //             setOptions(reviewers)
    //             setAllTimeZones(array);
    //         }
    //     }

    //     setInitialValues();
    //     return () => { unmounted = true };
    // }, []);


    return (
        <div>

            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ offerLetter: props.values.offerLetter }}>

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <CustomDropZone
                            selectedFile={props.values.offerLetter && ((props.values.offerLetter).length > 0) && props.values.offerLetter[0].name}
                            label="Upload Job Offer Letter"
                            miniLabel="(PDF files only)"
                            classLabel="defaultLabel"
                            isMultiUpload={false}
                            isImageUpload={false}
                            maxFileSize={5242880}
                            acceptFileTypes={"application/pdf"}
                            viewBoxIcon={
                                <svg width="62" height="51" viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M31 25.5V44.625" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M52.6739 39.0789C55.1936 37.949 57.184 36.161 58.3311 33.9972C59.4782 31.8334 59.7167 29.417 59.0088 27.1294C58.301 24.8417 56.6871 22.8131 54.422 21.3637C52.1569 19.9143 49.3695 19.1267 46.4998 19.1251H43.2448C42.4628 16.6373 41.0054 14.3276 38.9821 12.3698C36.9588 10.4119 34.4223 8.85683 31.5632 7.82144C28.7041 6.78605 25.5969 6.29729 22.4751 6.3919C19.3533 6.48651 16.2982 7.16204 13.5395 8.36769C10.7808 9.57334 8.39021 11.2777 6.54755 13.3528C4.70488 15.4278 3.45806 17.8194 2.90081 20.3479C2.34356 22.8763 2.49038 25.4758 3.33024 27.9508C4.17011 30.4259 5.68115 32.7121 7.74978 34.6376" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            }
                            uploadFileTopic={'Drag and Drop or Click to select file'}
                            maximumFileSizeInMBLabel={'5'}
                            setFieldValue={setFieldValue}
                            name='offerLetter'
                            errorMessage={submitCount > 0 && errors.offerLetter}
                            isInvalid={(submitCount > 0 && errors.offerLetter) ? true : false}
                        />

                        <div className="mt-4 mb-3">
                            <CustomButton
                                buttonType="submit"
                                label="Review"
                                type="primaryBtn"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default SendOfferConfigurations;
